<script setup>
import { useTranslation, } from '@/assets/js/src/util/composables'

defineProps({
    bibles: {
        type: Array,
        default: (() => []),
    },
    locale: {
        type: String,
        default: 'en',
    },
})

const { t, } = useTranslation()
</script>

<template>
    <div>
        <h2 class="mt-5 mb-2">
            {{ t('async.webmasters.manual_links.heading') }}
        </h2>
        <div v-html="t('async.webmasters.manual_links.text')"></div>
        <h3>{{ t('async.webmasters.manual_links.bible_link.heading') }}</h3>
        <div v-html="t('async.webmasters.manual_links.bible_link.text')"></div>
        <h3>{{ t('async.webmasters.manual_links.search_link.heading') }}</h3>
        <div v-html="t('async.webmasters.manual_links.search_link.text')"></div>
        <h3>{{ t('async.webmasters.manual_links.hint_translation.heading') }}</h3>
        <div v-html="t('async.webmasters.manual_links.hint_translation.text')"></div>
        <h4 class="mt-4 mb-2">
            {{ t('async.webmasters.manual_links.bibles_table.heading') }}
        </h4>
        <v-no-ssr>
            <v-data-table
                :locale="locale"
                :headers="[
                    {
                        title: t('async.webmasters.manual_links.bibles_table.abbreviation'),
                        align: 'left',
                        sortable: false,
                        value: 'abbr'
                    },
                    {
                        title: t('async.webmasters.manual_links.bibles_table.name'),
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    },
                    {
                        title: t('async.webmasters.manual_links.bibles_table.language'),
                        align: 'left',
                        sortable: false,
                        value: 'language'
                    },
                    {
                        title: t('async.webmasters.manual_links.bibles_table.section'),
                        align: 'left',
                        sortable: false,
                        value: 'section'
                    },
                ]"
                :footer-props="{itemsPerPageOptions:[20]}"
                :items="bibles"
            >
                <template #items="{item}">
                    <td>{{ item.abbr }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.language }}</td>
                    <td>{{ item.section }}</td>
                </template>
            </v-data-table>
        </v-no-ssr>
        <h3>{{ t('async.webmasters.manual_links.hint_bible_passages.heading') }}</h3>
        <div v-html="t('async.webmasters.manual_links.hint_bible_passages.text')"></div>
    </div>
</template>
